import ImmunizationTdapViewNew from "./ImmunizationTdapViewNew";

export default ImmunizationTdapViewNew;
